export default {
    reviewOrder: {
        reviewOrder: "Esamina l'ordine"
    }
}